module.exports = __webpack_public_path__ + "img/brand-clark.4adee695.svg";